import {useEffect, useState} from "react";
import moment from "moment-timezone";
import "moment-timezone";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

import useCustomTranslation from "core/customTranslation";
import translations from "../translations";

const IslandsSavingListTable = ({itemsShown, targetPercentage, actualCollections}) => {
    const {t: tC} = useCustomTranslation(translations);

    const renderValue = (val) => {
        if (val === null || val === undefined || val === "") return "-";
        if (typeof val === "number") {
            return val % 1 === 0 ? val : val.toFixed(2).replace(".", ",");
        }
        return val;
    };

    const renderDias = (truncated, raw) => {
        if (truncated === null || truncated === undefined) return "-";
        if (raw !== null && raw !== undefined && raw !== truncated) {
            return (
                <OverlayTrigger placement="top" overlay={<Tooltip>{raw.toFixed(2).replace(".", ",")}</Tooltip>}>
                    <span style={{cursor: "help", borderBottom: "1px dashed #999"}}>{truncated}</span>
                </OverlayTrigger>
            );
        }
        return truncated;
    };

    const getLevelColor = (value) => {
        if (value === null || value === undefined) return "transparent";
        if (value >= 75) return "rgba(244, 67, 54, 0.7)";
        if (value >= 50) return "rgba(76, 175, 80, 0.7)";
        if (value >= 30) return "rgba(33, 150, 243, 0.7)";
        return "rgba(255, 235, 59, 0.7)";
    };

    const savingsPcts =
        itemsShown && itemsShown.length > 0
            ? itemsShown
                  .map((item) => {
                      const sav = item.recogidas_year != null ? Math.max(0, actualCollections - item.recogidas_year) : null;
                      return sav != null && actualCollections > 0 ? Math.round((sav / actualCollections) * 10000) / 100 : null;
                  })
                  .filter((p) => p !== null)
            : [];
    const avgPct =
        savingsPcts.length > 0 ? Math.round((savingsPcts.reduce((a, b) => a + b, 0) / savingsPcts.length) * 100) / 100 : null;

    return (
        <div className="col-12" style={{overflowX: "auto"}}>
            <hr className="mb-3" />
            {!itemsShown || itemsShown.length === 0 ? (
                <div className="alert alert-secondary text-center">{tC("filters.noData")}</div>
            ) : (
                <table className="table table-striped" style={{fontSize: "0.85em"}}>
                    <thead>
                        <tr>
                            <th
                                colSpan="2"
                                className="text-center border-start"
                                style={{
                                    borderBottom: "1px solid #7e7e7e",
                                    borderRight: "1px solid #7e7e7e",
                                    verticalAlign: "middle",
                                }}></th>
                            <th
                                colSpan="2"
                                className="text-center border-start"
                                style={{
                                    borderBottom: "1px solid #7e7e7e",
                                    borderRight: "1px solid #7e7e7e",
                                    verticalAlign: "middle",
                                }}>
                                {tC("tables.mediaSummary")}
                            </th>
                            <th
                                colSpan="5"
                                className="text-center"
                                style={{
                                    borderBottom: "1px solid #7e7e7e",
                                    borderRight: "1px solid #7e7e7e",
                                    verticalAlign: "middle",
                                }}>
                                {tC("tables.daysToNextCollection")}
                            </th>
                            <th
                                colSpan="4"
                                className="text-center border-start"
                                style={{borderBottom: "1px solid #7e7e7e", verticalAlign: "middle"}}>
                                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", gap: "8px"}}>
                                    <span>{tC("tables.savings")}</span>
                                    {avgPct !== null && (
                                        <span
                                            style={{
                                                fontSize: "1em",
                                                fontWeight: "normal",
                                                padding: "1px 6px",
                                                borderRadius: "3px",
                                                background: "#e9ecef",
                                                border: "1px solid #ced4da",
                                                whiteSpace: "nowrap",
                                            }}>
                                            {tC("tables.totalSavingsBadge")} {avgPct}%
                                        </span>
                                    )}
                                </div>
                            </th>
                        </tr>
                        <tr>
                            <th className="border-start" style={{width: "120px"}}>
                                {tC("tables.island")}
                            </th>
                            <th style={{borderRight: "1px solid #7e7e7e", width: "100px"}}>{tC("tables.wasteType")}</th>
                            <th
                                className="text-center border-start"
                                style={{width: "80px"}}
                                title={tC("tables.mediaLinealTitle")}>
                                {tC("tables.mediaLineal")}
                            </th>
                            <th
                                className="text-center"
                                style={{borderRight: "1px solid #7e7e7e", width: "80px"}}
                                title={tC("tables.mediaIslandTitle")}>
                                {tC("tables.mediaIsland")}
                            </th>
                            <th className="text-center" style={{width: "55px"}}>
                                50%
                            </th>
                            <th className="text-center" style={{width: "55px"}}>
                                60%
                            </th>
                            <th className="text-center" style={{width: "55px"}}>
                                70%
                            </th>
                            <th className="text-center" style={{width: "55px"}}>
                                80%
                            </th>
                            <th className="text-center" style={{width: "55px"}}>
                                90%
                            </th>
                            <th
                                className="text-center"
                                style={{width: "55px", borderLeft: "1px solid #7e7e7e", fontWeight: "bold"}}>
                                Porcentaje Recogida ({targetPercentage || 100}%)
                            </th>
                            <th
                                className="text-center border-start"
                                style={{width: "90px"}}
                                title={tC("tables.anualCollections")}>
                                {tC("tables.anualCollections")}
                            </th>
                            <th className="text-center" style={{width: "70px"}} title={tC("tables.savings")}>
                                {tC("tables.savings")}
                            </th>
                            <th className="text-center" style={{width: "60px"}} title={tC("tables.percentageSavings")}>
                                {tC("tables.percentageSavings")}
                            </th>
                        </tr>
                    </thead>
                    <tbody id="data-list">
                        {itemsShown.map((item, index) => {
                            const savings =
                                item.recogidas_year != null ? Math.max(0, actualCollections - item.recogidas_year) : null;
                            const percentage =
                                savings != null && actualCollections > 0
                                    ? Math.round((savings / actualCollections) * 10000) / 100
                                    : null;
                            return (
                                <tr key={"islt-" + index}>
                                    <td className="border-start">{item.island_name}</td>
                                    <td style={{borderRight: "1px solid #7e7e7e"}}>{item.waste_types}</td>
                                    <td className="text-center">{renderValue(item.media_llenado_lineal)}</td>
                                    {/* TODO - ISLAND MEDIA FALTA */}
                                    <td
                                        className="text-center border-start"
                                        style={{
                                            borderRight: "1px solid #7e7e7e",
                                            backgroundColor: getLevelColor(item.media_contenedor),
                                        }}>
                                        {renderValue(item.media_contenedor)}
                                    </td>
                                    <td className="text-center">{renderDias(item.dias_50, item.dias_50_raw)}</td>
                                    <td className="text-center">{renderDias(item.dias_60, item.dias_60_raw)}</td>
                                    <td className="text-center">{renderDias(item.dias_70, item.dias_70_raw)}</td>
                                    <td className="text-center">{renderDias(item.dias_80, item.dias_80_raw)}</td>
                                    <td className="text-center">{renderDias(item.dias_90, item.dias_90_raw)}</td>
                                    <td className="text-center" style={{borderLeft: "1px solid #7e7e7e", fontWeight: "bold"}}>
                                        {renderDias(item.dias_target, item.dias_target_raw)}
                                    </td>
                                    <td className="text-center border-start">{renderValue(item.recogidas_year)}</td>
                                    <td className="text-center">{renderValue(savings)}</td>
                                    <td className="text-center" style={{fontWeight: "bold"}}>
                                        {renderValue(percentage)}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default IslandsSavingListTable;
